module.exports = __webpack_public_path__ + "img/smrz.93667476.png";